/* tslint:disable */

/**
 */
export class PackingLayer {
    ID_PACKING_LAYER?: number;
    ID_PACKING?: number;
    ID_PACKING_ELMT?: number;
    THICKNESS?: string;
    PACKING_SIDE_NUMBER?: number;
    PACKING_LAYER_ORDER?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/packing-layer.ts